// removed by extract-text-webpack-plugin
module.exports = {"codeInput":"CodeInput--codeInput--A4KbIiUg","codeBox":"CodeInput--codeBox--VU42peZ6"};


//////////////////
// WEBPACK FOOTER
// ./src/App/auth/components/CodeInput.css
// module id = 1310
// module chunks = 2